import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Wizard from 'core/components/wizard'
import wizardsShape from 'core/components/wizard/shapes'
import aSteps from './steps'

const Theming = props => {
  const { setWizards, wizards } = props //resetConfiguratorWizard
  const { aStepsTheming } = wizards
  const aStepsActive = wizards.aStepsTheming

  useEffect(() => {
    const extendedAStepsTheming = aSteps.map(
      item => aStepsTheming.filter(step => step.hash === item.hash)[0]
    )

    const extendedWizard = {
      ...wizards,
      activeWizard: 'aStepsTheming',
      aStepsTheming: extendedAStepsTheming
    }

    setWizards(extendedWizard)
  }, [])

  return <Wizard aSteps={aSteps} aStepsActive={aStepsActive} />
}

Theming.propTypes = {
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired
}

export default Theming
